export const locales = ["am", "en"]

export const name = "Sps.am";

export const languages = [
    {
        code: "am",
        name: "Armenian",
        country_code: "ՀԱՅ",
    },
    {
        code: "en",
        name: "English",
        country_code: "ENG",
    }
];

import { all } from "../assets/svgs";

export const filters = [
    {
        name: "all",
        icon: all.icon,
    },
    {
        name: "pages",
    },
    {
        name: "news",
    }
]